import {
    GET_ORGANIZATION_CONTACT,
    CREATE_ORGANIZATION_CONTACT,
    UPDATE_ORGANIZATION_CONTACT,
    REMOVE_ORGANIZATION_CONTACT
} from "@/store/actions/organization_contact";

import organizationContactAPI from "@/utils/axios/organization_contact"

import {ALERT_SHOW} from "@/store/actions/alert";
import {START_MODAL_LOADING, STOP_MODAL_LOADING} from "@/store/actions/loading";

const state = { organization_contacts: [] }

const getters = {
    getOrganizationContacts: state => state.organization_contacts,
}

const actions = {
    [GET_ORGANIZATION_CONTACT]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            organizationContactAPI.get(payload)
                .then(response => response.data)
                .then(data => {
                    commit(GET_ORGANIZATION_CONTACT, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
        })
    },
    [CREATE_ORGANIZATION_CONTACT]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            organizationContactAPI.create(payload)
                .then(response => response.data)
                .then((data) => {
                    commit(CREATE_ORGANIZATION_CONTACT, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
    [UPDATE_ORGANIZATION_CONTACT]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            organizationContactAPI.update(payload)
                .then(response => response.data)
                .then(data => {
                    commit(UPDATE_ORGANIZATION_CONTACT, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
    [REMOVE_ORGANIZATION_CONTACT]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            organizationContactAPI.remove(payload)
                .then(response => response.data)
                .then(data => {
                    commit(REMOVE_ORGANIZATION_CONTACT, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
}

const mutations = {
    [GET_ORGANIZATION_CONTACT]: (state, payload) => {
        state.organization_contacts = payload
    },
    [CREATE_ORGANIZATION_CONTACT]: (state, payload) => {
        state.organization_contacts.push(payload)
    },
    [UPDATE_ORGANIZATION_CONTACT]: (state, payload) => {
        let obj = state.organization_contacts.find(item => item.id === payload.id)
        if (obj) {
            Object.keys(payload).forEach(item => {
                obj[item] = payload[item]
            })
        }
    },
    [REMOVE_ORGANIZATION_CONTACT]: (state, payload) => {
        const obg = state.organization_contacts.find(item => item.id === payload.id)
        const obj_id = state.organization_contacts.indexOf(obg)
        if (obg) {
            state.organization_contacts.splice(obj_id, 1)
        }
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}